import heroImage from '@/assets/image/blog/blogDetail2/hero.png'
import cardImage1 from '@/assets/image/blog/Blog_1.png'
import cardImage2 from '@/assets/image/blog/Blog_2.png'
import cardImage3 from '@/assets/image/blog/Blog_3.png'
import authorSj from '@/assets/image/blog/blogDetail2/author_sj.png'
import authorNova from '@/assets/image/blog/blogDetail2/author_nova.jpg'
import authorNathan from '@/assets/image/podcast/vishwa_head.png'
import authorJustin from '@/assets/image/home/Author3.png'
import Author4 from '@/assets/image/home/Author4.png'
import Author5 from '@/assets/image/home/Author5.png'
import executionVerificationContent from './content/executionVerification'
import agentNativeBankingContent from './content/agentNativeBanking'
import fraudsInAiEraContent from './content/fraudsInAiEra'
import selectiveDisclosureContent from './content/selectiveDisclosure'
import agentNativeBankingHero from '@/assets/image/blog/local/agent-native-banking/hero.png'
import fraudsInAiEraHero from '@/assets/image/blog/Blog_2.png'
import selectiveDisclosureHero from '@/assets/image/blog/local/selective-disclosure/hero.png'

const authorMap = {
  sj: { name: 'SJ Liang', avatar: authorSj },
  nova: { name: 'Nova Wang', avatar: authorNova },
  justin: { name: 'Justin Cheng', avatar: authorJustin },
  parth: { name: 'Parth Gargava', avatar: Author4 },
  canice: { name: 'Canice Wu', avatar: Author5 },
}

export const featuredPost = {
  slug: 'execution-verification',
  tag: 'Execution Verification',
  title: 'The Missing Layer for Agent-Driven Capital',
  summary:
    'Explained why signatures prove authorization but not correctness, and why agent-driven finance requires pre-execution verification before capital moves.',
  image: heroImage,
  to: '/blogDetail?slug=execution-verification',
  external: false,
  authors: [authorMap.justin, authorMap.nova, authorMap.sj],
  sourceUrl: 'https://www.vishwalab.com/',
  sourceLabel: 'Learn more on Vishwa',
  detailSections: executionVerificationContent,
}

export const postCards = [
  {
    slug: 'agent-native-banking',
    tag: 'Agent-Native Banking',
    title: 'Why Autonomous Capital Requires a Verification Layer',
    summary:
      'Introduced the thesis that autonomous capital needs a new banking stack, where authorization, solvency, and intent are verified before execution.',
    image: cardImage1,
    detailHeroImage: agentNativeBankingHero,
    to: '/blogDetail?slug=agent-native-banking',
    external: false,
    sourceUrl:
      'https://medium.com/vishwa-research/agent-native-banking-why-autonomous-capital-requires-a-verification-layer-aaf8cec42775',
    authors: [authorMap.nova,authorMap.sj],
    detailSections: agentNativeBankingContent,
  },
  {
    slug: 'frauds-in-ai-era',
    tag: 'Frauds in AI Era',
    title: 'New Angles, New Neutralizations',
    summary:
      'Mapped how AI expands the fraud surface from prompts to payments, and argued that financial systems need verifiable safeguards before autonomous actions execute.',
    image: cardImage2,
    detailHeroImage: fraudsInAiEraHero,
    to: '/blogDetail?slug=frauds-in-ai-era',
    external: false,
    sourceUrl:
      'https://medium.com/vishwa-research/frauds-in-ai-era-new-angles-new-neutralizations-74b1dcec07c4',

    authors: [authorMap.sj,authorMap.nova],
    detailSections: fraudsInAiEraContent,
  },
  {
    slug: 'selective-disclosure',
    tag: 'Privacy Is Neither Anonymity nor Secrecy',
    title: 'Why Selective Disclosure Is the Next Primitive',
    summary:
      'Argued that privacy is not about hiding everything, but about revealing only what must be proven, making selective disclosure a core primitive for institutional onchain systems.',
    image: cardImage3,
    detailHeroImage: selectiveDisclosureHero,
    to: '/blogDetail?slug=selective-disclosure',
    external: false,
    sourceUrl:
      'https://medium.com/vishwa-research/privacy-is-neither-anonymity-nor-secrecy-why-selective-disclosure-is-the-next-primitive-5f8ee6d8c482',
    authors: [authorMap.parth, authorMap.canice, authorMap.sj, authorMap.justin, authorMap.nova],
    detailSections: selectiveDisclosureContent,
  },
]

const allPosts = [featuredPost, ...postCards]

export const getPostBySlug = (slug) => allPosts.find((post) => post.slug === slug)